<template>
    <section class="space-standard container">
        <div class="bg-red-500 px-3 py-4">
            <p class="text-white">Błąd podczas pobierania komponentu</p>
        </div>
    </section>
</template>
